<form [formGroup]="form">
  <kodit-email-receivers-form
    [strankaId]="strankaId"
    [from]="form.controls.fromId"
    [toFormArray]="form.controls.to"
    [ccFormArray]="form.controls.cc"
  ></kodit-email-receivers-form>
</form>
